import { BodyText, Col, Row, TitleText } from '@policygenius/mortar';
import classnames from 'classnames';
import startCase from 'lodash/startCase';
import { Helmet } from 'react-helmet';
import { createUseStyles } from 'react-jss';

import navigatorStyles from './NavigatorContent.styles';
import { NavigatorContentProps } from './types';

const useStyles = createUseStyles(navigatorStyles);
const NavigatorContent: React.FC<NavigatorContentProps> = ({
  children,
  heading,
  subHeading,
  className,
  title,
}) => {
  const classes = useStyles();

  return (
    <>
      {title && (
        <Helmet titleTemplate="%s | Policygenius">
          <title>{startCase(title)}</title>
        </Helmet>
      )}
      <Row className={classnames(className, classes.wrapper)}>
        <Col
          className={classes.heading}
          push={{ small: 0, medium: 2, large: 3 }}
          span={{ small: 4, medium: 8, large: 6 }}
        >
          <TitleText as="h1" size="xlarge">
            {heading}
          </TitleText>
          {subHeading && (
            <BodyText size="large" className={classes.subHeading}>
              {subHeading}
            </BodyText>
          )}
        </Col>
        <>{children}</>
      </Row>
    </>
  );
};

export default NavigatorContent;
